export default __webpack_public_path__ + "static/nexgen-curriculum-tree-73968bca15cd81cc91b12857ddfea97a.png";